import React from 'react';

import { CategoryDashboard } from '../modules/audience-category-dashboard';

const sortingOptions = [
    {
        label: 'Sort by: Name',
        value: 'name',
        direction: 'asc',
    },
    {
        label: 'Sort by: Newest',
        value: '_created',
        direction: 'desc',
    },
    {
        label: 'Sort by: Last Updated',
        value: 'lastRefreshed',
        direction: 'desc',
    },
];

const CategoryVisitationLayout = ({
    audienceSegments,
    onSearch,
    segmentCount,
    activeAudience,
    organizationId,
}) => {
    const linkToAudienceTab = {
        pathname: '/audiences/all',
        query: { audienceTab: 'pelmorex_data' },
        linkBackLabel: 'Pelmorex Data',
    };

    return (
        <CategoryDashboard
            audienceSegments={audienceSegments}
            onSearch={onSearch}
            segmentCount={segmentCount}
            activeAudience={activeAudience}
            organizationId={organizationId}
            sortingOptions={sortingOptions}
            description={
                'By connecting mobile location signals to mapped points of interest, these segments identify consumers who have visited locations within specific category (eg., coffee shops, hardware stores) in the last 30 days.'
            }
            title={'Category Visitation'}
            linkToAudienceTab={linkToAudienceTab}
            bannerImagePath={'/images/audience-segments/banners/category visitation-banner.png'}
        />
    );
};

export default CategoryVisitationLayout;
